<template>
  <article class="q-row" :class="{ 'q-row--new': isNew }">
    <div class="q-top">
      <avatar
        class="q-avatar"
        color="#fff"
        :username="fullName"
        :backgroundColor="avatarColor"
      />
      <div class="q-author">
        <span class="q-name">{{ fullName }}</span>
        <span v-if="company" class="q-company">{{ company }}</span>
      </div>
      <div class="q-meta">
        <new-feature-tag v-if="isNew" />
        <time v-if="Posted" :datetime="Posted" :title="$moment(Posted).format('LLL')">
          {{ $moment(Posted).fromNow() }}
        </time>
      </div>
    </div>

    <h3 class="q-subject">
      <router-link :to="`/questions/${Tid}`" class="q-link">
        <span v-html="Subject"></span>
      </router-link>
    </h3>

    <div class="q-bottom">
      <span v-if="Fname" class="q-category">{{ Fname }}</span>
      <span class="q-comments" :class="{ 'q-comments--none': !commentCount }">
        <span class="material-icons" aria-hidden="true">chat_bubble_outline</span>
        {{ commentCount }} {{ commentCount === 1 ? "comment" : "comments" }}
      </span>
      <span class="q-view" aria-hidden="true">
        View <span class="material-icons">arrow_forward</span>
      </span>
    </div>
  </article>
</template>

<script>
import NewFeatureTag from "../components/Atoms/NewFeatureTag.vue";
import Avatar from "../components/Atoms/Avatar.vue";

export default {
  name: "HomeQuestion",
  components: { NewFeatureTag, Avatar },
  props: {
    FirstName: { type: String, default: "" },
    LastName: { type: String, default: "" },
    company: { type: String, default: "" },
    Posted: { type: [String, Date], default: null },
    Fname: { type: String, default: "" },
    Subject: { type: String, default: "" },
    Tid: { type: [String, Number], required: true },
    replies: { type: [String, Number], default: 1 },
    Fid: { type: [String, Number], default: null },
  },
  computed: {
    fullName() {
      return `${this.FirstName} ${this.LastName}`.trim() || "Unknown";
    },
    // The first "reply" is the original post
    commentCount() {
      return Math.max(0, Number(this.replies || 1) - 1);
    },
    isNew() {
      const lastActivity = this.$store.state.user?.LastActivity;
      return (
        this.$store.state.newPostCount > 0 &&
        !!this.Posted &&
        !!lastActivity &&
        this.$moment(this.Posted).isAfter(lastActivity)
      );
    },
    // Same person always gets the same color (no flicker on re-render)
    avatarColor() {
      const colors = this.$store.state.colors || ["#429da8"];
      let hash = 0;
      for (const ch of this.fullName) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
      return colors[hash % colors.length];
    },
  },
};
</script>

<style scoped>
.q-row {
  position: relative;
  padding: 16px 20px;
  border-bottom: 1px solid #eef0f2;
  transition: background 0.15s ease;
}
.q-row:last-child {
  border-bottom: none;
}
.q-row:hover {
  background: #f7f9fa;
}
.q-row--new {
  box-shadow: inset 3px 0 0 #f16232;
}

.q-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.q-avatar {
  flex-shrink: 0;
}
.q-author {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}
.q-name {
  font-weight: 600;
  color: #1e3040;
  font-size: 15px;
}
.q-company {
  color: #737373;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.q-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  color: #8a96a3;
  font-size: 13px;
  white-space: nowrap;
}

.q-subject {
  font-size: 17px;
  font-weight: 500;
  line-height: 1.35;
  margin: 0 0 10px;
}
.q-link,
.q-link:hover,
.q-link:focus {
  color: #1e3040;
  text-decoration: none !important;
  outline: none;
}
/* Whole row is clickable */
.q-link::after {
  content: "";
  position: absolute;
  inset: 0;
}
.q-row:has(.q-link:focus-visible) {
  outline: 2px solid #429da8;
  outline-offset: -2px;
}
.q-subject :deep(*) {
  font-size: inherit;
  margin: 0;
}

.q-bottom {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}
.q-category {
  background: #eef3f5;
  color: #4d5967;
  border-radius: 999px;
  padding: 3px 10px;
  max-width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.q-comments {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #4d5967;
}
.q-comments--none {
  color: #a3abb3;
}
.q-comments .material-icons {
  font-size: 16px;
}
.q-view {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #429da8;
  font-weight: 500;
}
.q-view .material-icons {
  font-size: 16px;
  transition: transform 0.2s;
}
.q-row:hover .q-view .material-icons {
  transform: translateX(3px);
}
</style>
